import { Group, Badge } from '@mantine/core';
import { ExpertiseBadge } from './ExpertiseBadge';
import { MentorExpertise } from '@/types/mentor';

interface ExpertiseBadgeGroupProps {
  expertises: MentorExpertise[];
  maxVisible?: number;
  justify?: 'center' | 'left' | 'right';
}

export function ExpertiseBadgeGroup({ 
  expertises, 
  maxVisible = 5,
  justify = 'center' 
}: ExpertiseBadgeGroupProps) {
  if (!expertises || expertises.length === 0) return null;
  
  const visibleExpertises = expertises.slice(0, maxVisible);
  const hasOverflow = expertises.length > maxVisible;
  
  return (
    <Group gap={4} justify={justify} style={{ flexWrap: 'wrap', maxWidth: '100%' }}>
      {visibleExpertises.map((exp) => (
        <ExpertiseBadge key={exp.expertise.id} name={exp.expertise.name} />
      ))}
      {hasOverflow && (
        <Badge
          variant="light"
          size="xs"
          styles={{ root: { paddingLeft: 6, paddingRight: 6 } }}
          color="blue"
        >
          +{expertises.length - maxVisible}
        </Badge>
      )}
    </Group>
  );
}
